// extracted by mini-css-extract-plugin
export default {"overviewAndMapSection":"mZ8Ow1","overviewPanel":"yFp47Z"};